import React from "react";
import { ReactComponent as Trash } from "../../images/trash-bin.svg";

const TrashBin = () => {
  return <Trash className="events__delete-icon" />;
};

export default TrashBin;
